import { useId } from 'react'
import { Button } from '../ui/Button'

const TYPES = ['image/png', 'image/jpeg', 'image/gif', 'video/mp4', 'video/webm', 'text/plain']
export function ReportAttachments({ files, onChange, onError, disabled = false, child = false }: {
  files: File[]; onChange: (files: File[]) => void; onError: (error: string) => void; disabled?: boolean; child?: boolean
}) {
  const id = useId()
  function pick(list: FileList | null) {
    if (!list) return
    const next = [...files]
    for (const file of Array.from(list)) {
      if (!TYPES.includes(file.type)) { onError('Use PNG, JPEG, GIF, MP4, WebM or a text file.'); continue }
      if (file.size > 8 * 1024 * 1024) { onError('That file is over the 8 MB limit.'); continue }
      if (next.length >= 4) { onError('Four attachments is the limit.'); break }
      next.push(file)
    }
    onChange(next)
  }
  return <div className="mt-3">
    <label htmlFor={id} className="block text-[13px] text-terra-deep">{child ? 'Add a screenshot or clip' : 'Add screenshots or clips'}</label>
    <input id={id} type="file" multiple accept={TYPES.join(',')} disabled={disabled} className="mt-2 w-full min-w-0 text-[12px] text-ink-muted" onChange={e => { pick(e.target.files); e.target.value = '' }} />
    <p className="mt-1 text-[12px] text-ink-muted">Optional: up to 4 files, 8 MB each. PNG, JPEG, GIF, MP4, WebM or text.</p>
    {files.length > 0 && <ul className="mt-2 space-y-2 text-[12px] text-ink-muted">{files.map((file, i) => <li key={i} className="flex items-center justify-between gap-2"><span className="min-w-0 break-all">{file.name}</span><Button variant="ghost" size="sm" disabled={disabled} aria-label={`Remove ${file.name}`} onClick={() => onChange(files.filter((_, index) => index !== i))}>Remove</Button></li>)}</ul>}
  </div>
}

export function ReportEvidenceStatus({ failedFiles, uploadedCount, busy, onRetry, onRemove }: { failedFiles: File[]; uploadedCount: number; busy: boolean; onRetry: () => void; onRemove: (index: number) => void }) {
  return <div className="mt-3 text-[13px] text-ink-muted" aria-live="polite">
    {uploadedCount > 0 && <p>{uploadedCount} attachment{uploadedCount === 1 ? '' : 's'} uploaded.</p>}
    {failedFiles.length > 0 && <><p>Your report was received. These attachments were not uploaded:</p><ul>{failedFiles.map((file, i) => <li key={i} className="flex flex-wrap items-center gap-2 break-all">{file.name} — not uploaded <Button variant="ghost" size="sm" disabled={busy} aria-label={`Remove failed ${file.name}`} onClick={() => onRemove(i)}>Remove</Button></li>)}</ul><Button className="mt-2" variant="outline" disabled={busy} onClick={onRetry}>{busy ? 'Uploading…' : 'Retry failed attachments'}</Button></>}
  </div>
}
